export const SET_SEARCH_DATA = 'SET_SEARCH_DATA';
